import { render, staticRenderFns } from "./wePay.vue?vue&type=template&id=7ca7a534&scoped=true"
import script from "./wePay.vue?vue&type=script&lang=js"
export * from "./wePay.vue?vue&type=script&lang=js"
import style0 from "./wePay.vue?vue&type=style&index=0&id=7ca7a534&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca7a534",
  null
  
)

export default component.exports